let pinyinEngine = function () {
  pinyinEngine.cache();
  return (this instanceof pinyinEngine) ? this.resetCache() : new pinyinEngine;
};
pinyinEngine.isFirstLetterSearchable = true;
pinyinEngine.prototype = {
  search: function (keyword, callback) {
    let cache = this._cache,
      history = this._history,
      value = [];

    keyword = keyword.toLowerCase();
    callback = callback || function () {};

    if (history.length && keyword.indexOf(history.keyword) === 1) {
      cache = history.content;
    }

    for (let i = 0, len = cache.length, val; i < len; i ++) {
      val = cache[i];
      if (val.tags.toLowerCase().indexOf(keyword.toLowerCase()) !== -1) {
        value.push(val);
        callback(val.content);
      }
    }
    this._history = {
      keyword: keyword,
      value: value,
      length: value.length
    };
    return value;
  },

  setCache: function (tags, content) {
    let keys;
    keys = tags;
    for (let i = 0, len = tags.length; i < len; i ++) {
      let tempKeyArr = tags[i].split(' ');
      if(tempKeyArr.length <= 1){
        keys.push(tempKeyArr[0].substr(0,1));
      }else{
        let testInfo = "";
        for(let j = 0; j < tempKeyArr.length; j++){
          testInfo += tempKeyArr[j].substr(0,1);
        }
        keys.push(testInfo);
      }
    }
    let obj = {
      tags: keys[1]+content,
      content: content
    };
    this._cache.push(obj);
  },

  resetCache: function () {
    this._cache = [];
    this._history = {};
  }
};
pinyinEngine.cache = function () {
  let txt, w, k, l,
    data = pinyinEngine._data || [],
    word = data[0],
    key = data[1],
    cache = {},
    fromCharCode = String.fromCharCode;
  if (!data.length) return cache;
  if (typeof key === 'string') key = key.split(',');
  for (let i = 0, arrow = 0, len = word.length; i < len; i ++, arrow ++) {
    k = word[i];
    if (k < 0 || k === undefined) {
      arrow += Math.abs(k || 0);
      continue;
    }

    txt = fromCharCode(arrow + 19968);

    if (typeof k === 'number') {
      cache[txt] = [key[k]];
    } else {
      cache[txt] = [];
      l = k.length;
      for (w = 0; w < l; w ++) {
        cache[txt].push(key[k[w]]);
      }
    }
  }

  pinyinEngine.cache = function () {
    return cache;
  };
  return cache;
};

export default pinyinEngine;


// WEBPACK FOOTER //
// ./src/container/subscribe/pinyinEngine.js